export default __webpack_public_path__ + "static/media/FrontendDev-ResumeRiaz.d453f6b3.pdf";